/**
 * XML to JSON converter
 *
 * @module xml2json
 * @author timduck@cortona3d.com
 */

var XMLNodeData = require('XMLNodeData');

/**
 * Convert XML tree to JSON object
 * 
 * <node att1="att1-value" att2="att2-value">
 *      <foo>Foo</foo>
 *      <bar>
 *          <![CDATA[Bar]]>
 *      </bar>
 *      <items>
 *          <item>i1</item>
 *          <item>i2</item>
 *          <item>i3</item>
 *          <item>i4</item>
 *      </items>
 * </node>
 * 
 * {
 *  node: {
 *      "@attributes": {
 *          att1: "att1-value",
 *          att2: "att2-value"
 *      },
 *      foo: { "#text": "Foo" },
 *      bar: { "#text": "Bar" },
 *      items: {
 *          item: [
 *              { "#text": "i1" },
 *              { "#text": "i2" },
 *              { "#text": "i3" },
 *              { "#text": "i4" }
 *          ]
 *      }
 *  }
 * }
 * 
 * @param {DOMNode} xml The XML DOMNode
 * @returns {XMLNodeData} The JavaScript object
 */

/*
 * var json = xmlToJson(xmlNode);
 * /node/foo/text() --> json.node.foo['#text'] --> json.node.foo.$text()
 * /node/bar --> json.node.bar['#text'] --> json.node.bar.$text()
 * count(/node/children/item) --> json.$(json.node.children.item).length --> json.$('node/children/item').length
 * /node/children/item[2] --> json.node.children.item[1] --> json.$('node.children.item')[1]
 * /node/@att1 --> json.node['@attributes'].att1 --> json.node.$attr('att1')
 * 
 */ 

function xmlToJson(xml) {
    var obj = new XMLNodeData();

    if (xml.nodeType == 1) { // element
        // node name
        obj["@name"] = xml.nodeName;
        // attributes
        if (xml.attributes.length > 0) {
            obj["@attributes"] = {};
            for (var j = 0; j < xml.attributes.length; j++) {
                var attribute = xml.attributes.item(j);
                obj["@attributes"][attribute.nodeName] = attribute.nodeValue;
            }
        }
    }

    // children
    var hasText = false;
    var hasMultiText = false;
    var hasNodes = false;
    var hasCDATA = false;
    if (xml.hasChildNodes()) {
        obj['@children'] = [];
        for (var i = 0; i < xml.childNodes.length; i++) {
            var item = xml.childNodes.item(i);
            var nodeName = item.nodeName;
            var isElement = item.nodeType === 1;
            var isText = item.nodeType === 3;
            var child = xmlToJson(item);
            hasText = hasText || isText;
            hasNodes = hasNodes || !isText;
            hasCDATA = hasCDATA || item.nodeType === 4;
            if (typeof obj[nodeName] === "undefined") {
                obj[nodeName] = child;
            } else {
                if (typeof obj[nodeName].push === "undefined") {
                    hasMultiText = hasMultiText || isText;
                    var old = obj[nodeName];
                    obj[nodeName] = [];
                    obj[nodeName].push(old);
                }
                obj[nodeName].push(child);
            }
            if (isElement || (isText && child)) obj['@children'].push(child);
        }

        if (hasMultiText) {
            obj['#text'] = obj['#text'].join('').replace(/^[\s\r\n]*$/, '');
        }
        if (hasText && hasNodes) {
            delete obj['#text'];
        }
        if (hasCDATA) {
            obj['#text'] = obj['#cdata-section'];
            delete obj['#cdata-section'];
        }
    } else if (typeof xml.nodeValue === "string") {
        obj = xml.nodeValue.replace(/^[\s\r\n]*$/, '');
    }

    return obj;
}

module.exports = xmlToJson;